import api from './api';
import qs from 'qs';

const loginOptions = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
    authorization: `basic ${process.env.REACT_APP_AUTH_HEADER}`
  },
  fallbackReturnValue: {
    status: 'fail'
  }
};

export const getTokenLogin = (username, password) => {
  return api.post(
    '/connect/token',
    qs.stringify({
      grant_type: 'password',
      username: username,
      password: password
    }),
    loginOptions
  );
};
